var _g;
const _excluded = ["title", "titleId"];
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
function _objectWithoutProperties(e, t) { if (null == e) return {}; var o, r, i = _objectWithoutPropertiesLoose(e, t); if (Object.getOwnPropertySymbols) { var s = Object.getOwnPropertySymbols(e); for (r = 0; r < s.length; r++) o = s[r], t.includes(o) || {}.propertyIsEnumerable.call(e, o) && (i[o] = e[o]); } return i; }
function _objectWithoutPropertiesLoose(r, e) { if (null == r) return {}; var t = {}; for (var n in r) if ({}.hasOwnProperty.call(r, n)) { if (e.includes(n)) continue; t[n] = r[n]; } return t; }
import * as React from "react";
function SvgAiPlugins(_ref, svgRef) {
  let {
      title,
      titleId
    } = _ref,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    width: 2913.27,
    height: 2625.54,
    viewBox: "0 0 2913.27 2625.54",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _g || (_g = /*#__PURE__*/React.createElement("g", {
    id: "Layer_2",
    "data-name": "Layer 2"
  }, /*#__PURE__*/React.createElement("g", {
    id: "\\u0421\\u043B\\u043E\\u0439_1",
    "data-name": "\\u0421\\u043B\\u043E\\u0439 1"
  }, /*#__PURE__*/React.createElement("g", {
    id: "CHARACTER_S_LEGS",
    "data-name": "CHARACTER'S LEGS"
  }, /*#__PURE__*/React.createElement("line", {
    id: "SHADOW",
    x1: 1006.24,
    y1: 2621.9,
    x2: 2142.24,
    y2: 2621.9,
    fill: "none",
    stroke: "#ffcf2d",
    strokeLinecap: "round",
    strokeMiterlimit: 10,
    strokeWidth: 6
  }), /*#__PURE__*/React.createElement("g", {
    id: "CHAIR"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M1573.84,1617v445a394.85,394.85,0,0,0,187.6,336.1l164.1,101.2",
    fill: "none",
    stroke: "#66b0f0",
    strokeLinecap: "round",
    strokeLinejoin: "round",
    strokeWidth: 6
  }), /*#__PURE__*/React.createElement("path", {
    d: "M1484.94,1617v445a394.85,394.85,0,0,1-187.6,336.1l-164.1,101.2",
    fill: "none",
    stroke: "#66b0f0",
    strokeLinecap: "round",
    strokeLinejoin: "round",
    strokeWidth: 6
  }), /*#__PURE__*/React.createElement("path", {
    d: "M1425.24,1617h200.1a32,32,0,0,0,32-32v-50.5h-264.1V1585A32,32,0,0,0,1425.24,1617Z",
    fill: "#fff",
    stroke: "#66b0f0",
    strokeMiterlimit: 10,
    strokeWidth: 6
  }), /*#__PURE__*/React.createElement("path", {
    d: "M1932.94,2621.9a73.5,73.5,0,1,1,73.5-73.5,73.49,73.49,0,0,1-73.5,73.5",
    fill: "#fff",
    stroke: "#ffcf2d",
    strokeMiterlimit: 10,
    strokeWidth: 6
  }), /*#__PURE__*/React.createElement("path", {
    d: "M1131.64,2621.9a73.5,73.5,0,1,1,73.5-73.5,73.49,73.49,0,0,1-73.5,73.5",
    fill: "#fff",
    stroke: "#ffcf2d",
    strokeMiterlimit: 10,
    strokeWidth: 6
  }), /*#__PURE__*/React.createElement("path", {
    d: "M1131.64,2606.4a58,58,0,1,1,58-58,58,58,0,0,1-58,58",
    fill: "#fff",
    stroke: "#ffcf2d",
    strokeMiterlimit: 10,
    strokeWidth: 6
  }), /*#__PURE__*/React.createElement("path", {
    d: "M1932.64,2606.4a58,58,0,1,1,58-58,58,58,0,0,1-58,58",
    fill: "#fff",
    stroke: "#ffcf2d",
    strokeMiterlimit: 10,
    strokeWidth: 6
  }), /*#__PURE__*/React.createElement("path", {
    d: "M1421.34,2277s95.2-69.8,216.3,0",
    fill: "none",
    stroke: "#66b0f0",
    strokeLinecap: "round",
    strokeLinejoin: "round",
    strokeWidth: 6
  })), /*#__PURE__*/React.createElement("g", {
    id: "RIGHT_LEG",
    "data-name": "RIGHT LEG"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M1571.54,1494.6l-92,941.3H1763l233.1-847c42.9-138.2-49.4-278.8-193.1-279.1h-20C1676.64,1309.5,1586.44,1388.4,1571.54,1494.6Z",
    fill: "#31a1a9"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M1534.94,2435.9h149.4l-23.5,76.9c-29.5-29.4-70.6-50.6-115.5-53.3-4.2-.3-8.3-.4-12.4-.4Z",
    fill: "#e57281"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M1706.34,2621.3c7.8-72.4-68.6-156.2-161.1-161.9s-149.6,55.4-154.1,128c-.7,11-1.7,24.4.7,34.2Z",
    fill: "#fff",
    stroke: "#fe5244",
    strokeMiterlimit: 10,
    strokeWidth: 6
  }), /*#__PURE__*/React.createElement("polyline", {
    points: "1393.84 2595 1393.84 2595 1706.34 2598.7",
    fill: "none",
    stroke: "#fe5244",
    strokeMiterlimit: 10,
    strokeWidth: 6
  })), /*#__PURE__*/React.createElement("g", {
    id: "LEFT_LEG",
    "data-name": "LEFT LEG"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M1652.14,2435.9l236.5-144L1359.84,1406c-66.9-106.1-236.7-138.9-343.8-73.7h0c-123.5,75.2-147.7,244.3-50.3,351.1Z",
    fill: "#3fb1b5"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M1653.14,2431.9l237.5-142L1360.84,1406c-66.9-106.1-236.7-138.9-343.8-73.7h0c-123.5,75.2-147.7,244.3-50.3,351.1Z",
    fill: "none",
    stroke: "#fff",
    strokeMiterlimit: 10,
    strokeWidth: 6
  }), /*#__PURE__*/React.createElement("path", {
    d: "M1884.94,2285.6c-10.5-17.4-72,.3-137.4,39.7s-109.7,86.7-99.2,104.1,71.8-1.7,137.2-41S1895.34,2303.1,1884.94,2285.6Z",
    fill: "#73325a"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M1870.54,2398.2l-110.4,69.4-31.2-35-9.5-10.7-39.6-44.4c17-17.4,40.3-35.8,67.8-52.2,22.2-13.3,44.1-23.9,63.9-31.1l30.9,54.3,6.8,11.9Z",
    fill: "#e57281"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M2044.74,2473.5l-275,148.3h0a102.21,102.21,0,0,1-17.5-26,150.81,150.81,0,0,1-9.5-25.8c-16.2-60.8,6.7-130.5,79.8-165.3,64.5-30.7,144.8-13.1,191.2,27.3C2027.44,2444.1,2038.24,2458.2,2044.74,2473.5Z",
    fill: "#fff",
    stroke: "#fe5244",
    strokeMiterlimit: 10,
    strokeWidth: 6
  }), /*#__PURE__*/React.createElement("line", {
    x1: 2030.04,
    y1: 2451,
    x2: 1754.94,
    y2: 2599.3,
    fill: "none",
    stroke: "#fe5244",
    strokeLinecap: "round",
    strokeMiterlimit: 10,
    strokeWidth: 6
  }), /*#__PURE__*/React.createElement("path", {
    d: "M1842.24,2348.4a452.88,452.88,0,0,1-56.9,40,473.35,473.35,0,0,1-66.1,33.5l-41.6-44.4c17-17.4,42.3-35.8,69.8-52.2,22.2-13.3,44.1-24.9,63.9-32.1Z",
    fill: "#9a3b82"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M1878.84,2270.2c-10.5-17.4-76.9-.1-143.4,39.9s-108.7,86.9-98.2,104.3",
    fill: "none",
    stroke: "#fff",
    strokeMiterlimit: 10,
    strokeWidth: 6
  }))), /*#__PURE__*/React.createElement("g", {
    id: "TABLE"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M2799.44,1534.5a47.33,47.33,0,0,0,47.3-47.3v-181a47.33,47.33,0,0,0-47.3-47.3H169a47.33,47.33,0,0,0-47.3,47.3v181a47.33,47.33,0,0,0,47.3,47.3Z",
    fill: "#9a3b82"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M2798.64,1217.9H169.74a47.33,47.33,0,0,0-47.3,47.3v181a47.33,47.33,0,0,0,47.3,47.3h2628.9a47.33,47.33,0,0,0,47.3-47.3v-181A47.33,47.33,0,0,0,2798.64,1217.9Z",
    fill: "#fff",
    stroke: "#ffcf2d",
    strokeMiterlimit: 10,
    strokeWidth: 6
  }), /*#__PURE__*/React.createElement("line", {
    x1: 2661.74,
    y1: 1493.7,
    x2: 2661.74,
    y2: 2622.3,
    fill: "none",
    stroke: "#ffcf2d",
    strokeLinecap: "round",
    strokeMiterlimit: 10,
    strokeWidth: 6
  }), /*#__PURE__*/React.createElement("line", {
    x1: 366.84,
    y1: 1493.7,
    x2: 366.84,
    y2: 2622.3,
    fill: "none",
    stroke: "#ffcf2d",
    strokeLinecap: "round",
    strokeMiterlimit: 10,
    strokeWidth: 6
  })), /*#__PURE__*/React.createElement("g", {
    id: "PLANT"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M280.44,2341.4l-4.2,2.7L123.64,2109l-45.9,3.5a14.74,14.74,0,1,1,5.9-27.6l37.7,20.7-27.7-42.8-45.9,3.6a14.73,14.73,0,1,1,6-27.6l37.7,20.6-27.7-42.8-45.9,3.6a14.73,14.73,0,1,1,6-27.6l37.7,20.7-16.7-25.7-31-26.5a14.75,14.75,0,1,1,23.7-15.4L49,1984.8l17.2,26.5-3.6-44a14.71,14.71,0,1,1,27.6,5.8l-22.2,41,28.1,43.3-3.6-43.9a14.71,14.71,0,1,1,27.6,5.8l-22.2,41,28.1,43.3-3.6-43.9a14.71,14.71,0,1,1,27.6,5.8l-22.2,41Z",
    fill: "#9a3b82"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M536.84,2258.3c-73.3,147.7-172.3,250.4-230.8,243.3a41.38,41.38,0,0,1-13.5-4c-55.6-27.6-36.4-179.5,43-339.3,34-68.5,73.5-127.2,111.9-169.9,51.3-56.9,100.6-85.2,132.4-69.4C635.44,1946.6,616.14,2098.5,536.84,2258.3Z",
    fill: "#9a3b82"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M445,2141.6c-16.3,187.2-76.2,338.2-138.9,360a41.38,41.38,0,0,1-13.5-4c-55.6-27.6-36.4-179.5,43-339.3,34-68.5,73.5-127.2,111.9-169.9A1060,1060,0,0,1,445,2141.6Z",
    fill: "#ffcf2d"
  }), /*#__PURE__*/React.createElement("line", {
    x1: 579.84,
    y1: 1919,
    x2: 306.14,
    y2: 2501.6,
    fill: "none",
    stroke: "#ffcf2d",
    strokeMiterlimit: 10,
    strokeWidth: 6
  }), /*#__PURE__*/React.createElement("path", {
    d: "M574.64,2351l-38.7,13-25.8,18.1,43.8-5.2a14.75,14.75,0,0,1,16.3,17.1h0a14.75,14.75,0,0,1-21.1,10.7l-41.8-20.7L465,2413.7l43.8-5.2a14.73,14.73,0,1,1-4.8,27.8l-41.8-20.7L420,2445.3l43.8-5.2a14.73,14.73,0,1,1-4.9,27.8l-41.8-20.7-77.3,54.3h-8.7l83.3-58.5-5.2-45.7a14.73,14.73,0,1,1,27.8,4.9l-19.3,38.5,41.7-29.3-5.2-45.7a14.73,14.73,0,1,1,27.8,4.9l-19.2,38.4,41.7-29.3-5.2-45.7a14.73,14.73,0,1,1,27.8,4.9l-19.3,38.5,25.1-17.6,25.3-32a14.78,14.78,0,1,1,16.4,23.2Z",
    fill: "#ffcf2d"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M260.94,2493.8a81.47,81.47,0,0,1-15.7,3.6c-63,8.2-150-50.6-202.6-139.9-57.1-97-51.9-193.2,11.6-215,20.6-7.1,44.9-5.4,70.1,3.4,52.6,18.3,109.6,67.3,148.2,132.8C329.54,2375.8,324.34,2472,260.94,2493.8Z",
    fill: "#fff",
    stroke: "#ffcf2d",
    strokeMiterlimit: 10,
    strokeWidth: 6
  }), /*#__PURE__*/React.createElement("path", {
    d: "M260.94,2493.8a81.47,81.47,0,0,1-15.7,3.6c-58.2-26.4-108.8-138.2-119.5-274a633.78,633.78,0,0,1-1.4-77.5c52.6,18.3,109.6,67.3,148.2,132.8C329.54,2375.8,324.34,2472,260.94,2493.8Z",
    fill: "#ffcf2d"
  }), /*#__PURE__*/React.createElement("line", {
    x1: 30.14,
    y1: 2156.6,
    x2: 245.14,
    y2: 2497.4,
    fill: "none",
    stroke: "#ffcf2d",
    strokeMiterlimit: 10,
    strokeWidth: 6
  }), /*#__PURE__*/React.createElement("ellipse", {
    cx: 286.54,
    cy: 2130.7,
    rx: 126,
    ry: 374.9,
    fill: "#fff",
    stroke: "#ffcf2d",
    strokeMiterlimit: 10,
    strokeWidth: 6
  }), /*#__PURE__*/React.createElement("line", {
    x1: 286.54,
    y1: 1755.7,
    x2: 286.54,
    y2: 2505.6,
    fill: "none",
    stroke: "#ffcf2d",
    strokeMiterlimit: 10,
    strokeWidth: 6
  }), /*#__PURE__*/React.createElement("polyline", {
    points: "366.84 1845.6 286.54 1953.2 218.44 1818.4",
    fill: "none",
    stroke: "#ffcf2d",
    strokeLinecap: "round",
    strokeMiterlimit: 10,
    strokeWidth: 6
  }), /*#__PURE__*/React.createElement("polyline", {
    points: "392.94 1936.8 285.74 2084.2 189.34 1897.7",
    fill: "none",
    stroke: "#ffcf2d",
    strokeLinecap: "round",
    strokeMiterlimit: 10,
    strokeWidth: 6
  }), /*#__PURE__*/React.createElement("polyline", {
    points: "409.64 2042 284.74 2214.2 170.64 1994.2",
    fill: "none",
    stroke: "#ffcf2d",
    strokeLinecap: "round",
    strokeMiterlimit: 10,
    strokeWidth: 6
  }), /*#__PURE__*/React.createElement("polyline", {
    points: "417.44 2182.4 285.34 2367.2 160.84 2131",
    fill: "none",
    stroke: "#ffcf2d",
    strokeLinecap: "round",
    strokeMiterlimit: 10,
    strokeWidth: 6
  }), /*#__PURE__*/React.createElement("path", {
    d: "M473.34,2622.3H99.44a52.24,52.24,0,0,1-52.2-52.2v-16.3a52.24,52.24,0,0,1,52.2-52.2h373.9a52.24,52.24,0,0,1,52.2,52.2v16.3A52.17,52.17,0,0,1,473.34,2622.3Z",
    fill: "#fff",
    stroke: "#66b0f0",
    strokeMiterlimit: 10,
    strokeWidth: 6
  })), /*#__PURE__*/React.createElement("g", {
    id: "BOOKS"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M2674.54,1323h0c0,14.9-11.9,27-26.5,27h-407.3a26.72,26.72,0,0,1-26.5-27h0c0-14.9,11.9-27,26.5-27H2648C2662.64,1296,2674.54,1308.1,2674.54,1323Z",
    fill: "#fe5244"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M2502.64,1041.8h-166.7v116h322A162,162,0,0,0,2502.64,1041.8Z",
    fill: "#fff",
    stroke: "#ffcf2d",
    strokeMiterlimit: 10,
    strokeWidth: 6
  }), /*#__PURE__*/React.createElement("polygon", {
    points: "2365.94 1041.8 2365.94 1157.8 2296.94 1157.9 2296.94 1041.8 2365.94 1041.8",
    fill: "#ffcf2d",
    stroke: "#ffcf2d",
    strokeMiterlimit: 10,
    strokeWidth: 6
  }), /*#__PURE__*/React.createElement("path", {
    d: "M2913.24,1155.5l-255.3,2.3s63.9-86.6,239.3-63.7c0,0-137.2-28.6-276.4,0",
    fill: "none",
    stroke: "#ffcf2d",
    strokeMiterlimit: 10,
    strokeWidth: 6
  }), /*#__PURE__*/React.createElement("path", {
    d: "M2657.94,1157.8s111.9-61.5,248.3-31.7",
    fill: "none",
    stroke: "#ffcf2d",
    strokeMiterlimit: 10,
    strokeWidth: 6
  }), /*#__PURE__*/React.createElement("path", {
    d: "M2686.44,1252.7c0,10.9,1.7,20.8,4.4,28.1h-122.5c-6.3,0-11.5-5.5-11.5-12.2v-31.7c0-6.8,5.1-12.2,11.5-12.2h122.5C2688.14,1231.9,2686.44,1241.8,2686.44,1252.7Z",
    fill: "#ffcf2d"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M2556.94,1236.9v31.7a12.18,12.18,0,0,0,12.2,12.2h131.6v2.3a10.07,10.07,0,0,1-10.1,10.1h-460.3a10.07,10.07,0,0,1-10.1-10.1v-60.8a10.07,10.07,0,0,1,10.1-10.1h460.3a10.07,10.07,0,0,1,10.1,10.1v2.3h-131.6A12.34,12.34,0,0,0,2556.94,1236.9Z",
    fill: "#fff"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M2556.94,1236.9v31.7a12.18,12.18,0,0,0,12.2,12.2h131.6v2.3a10.07,10.07,0,0,1-10.1,10.1h-460.3a10.07,10.07,0,0,1-10.1-10.1v-60.8a10.07,10.07,0,0,1,10.1-10.1h460.3a10.07,10.07,0,0,1,10.1,10.1v2.3h-131.6A12.34,12.34,0,0,0,2556.94,1236.9Z",
    fill: "none",
    stroke: "#ffcf2d",
    strokeMiterlimit: 10,
    strokeWidth: 6
  }), /*#__PURE__*/React.createElement("path", {
    d: "M2385.44,1371.7c-4.8,4.5-7.8,12.7-7.8,19.6,0,13.7,12,27.8,26.8,27.8h368.8a11.71,11.71,0,0,1-11.7,11.7h-445.1a44.93,44.93,0,0,1-30.5-11.7,38.44,38.44,0,0,1-12.7-28.3c0-22.1,19.3-40,43.2-40h445.1a11.71,11.71,0,0,1,11.7,11.7v2.1h-368.8A27.51,27.51,0,0,0,2385.44,1371.7Z",
    fill: "#ffcf2d"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M2746.54,1364.5v53.6h26.6v4.5h-370a30.51,30.51,0,0,1-11.7-2.3h0a30.52,30.52,0,0,1-10.4-6.9,31.25,31.25,0,0,1,22.1-53.4h370v4.5Z",
    fill: "#fe5244"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M2756.84,1364.5v53.6h-352.4a26.8,26.8,0,0,1-26.8-26.8,27.09,27.09,0,0,1,7.8-19,26.68,26.68,0,0,1,18.9-7.8Z",
    fill: "#fff"
  }), /*#__PURE__*/React.createElement("line", {
    x1: 2756.84,
    y1: 1364.5,
    x2: 2756.84,
    y2: 1418.1,
    fill: "none",
    stroke: "#fe5244",
    strokeMiterlimit: 10,
    strokeWidth: 5
  }), /*#__PURE__*/React.createElement("path", {
    d: "M2453.54,1402.5v44.7h-30.9v-39a16.88,16.88,0,0,0-16.9-16.9h-13.8v-5.7h44.7A16.88,16.88,0,0,1,2453.54,1402.5Z",
    fill: "#fe5244"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M2774.64,1160.3h-525.4a24.58,24.58,0,0,0-24.6,24.6h0a24.63,24.63,0,0,0,24.6,24.5h525.4a24.58,24.58,0,0,0,24.6-24.6h0A24.69,24.69,0,0,0,2774.64,1160.3Z",
    fill: "#66b0f0"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M2655.44,1209.5h-5.3c.6,1.6,2.1,5.6,5.4,5.6,2,0,11.8-1.5,11.8-30.2,0-10.2-1.2-18-3.6-23.3-2.9-6.3-6.7-7-8.1-7-3.4,0-4.9,4.1-5.5,5.7h5.3a2.49,2.49,0,0,1,.5-.7c1.8.5,6.6,5.5,6.6,25.3s-4.8,24.7-6.6,25.3A1.79,1.79,0,0,1,2655.44,1209.5Z",
    fill: "#9a3b82"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M2698.84,1209.5h-5.3c.6,1.6,2.1,5.6,5.4,5.6,2,0,11.8-1.5,11.8-30.2,0-10.2-1.2-18-3.6-23.3-2.9-6.3-6.7-7-8.1-7-3.4,0-4.9,4.1-5.5,5.7h5.3a2.49,2.49,0,0,1,.5-.7c1.8.5,6.6,5.5,6.6,25.3s-4.8,24.7-6.6,25.3C2699.24,1210,2699,1209.8,2698.84,1209.5Z",
    fill: "#9a3b82"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M2742.34,1209.5H2737c.6,1.6,2.1,5.6,5.4,5.6,2.8,0,11.8-2.2,11.8-30.2s-9-30.2-11.8-30.2c-3.4,0-4.9,4.1-5.5,5.7h5.3a2.49,2.49,0,0,1,.5-.7c2,.5,6.6,5.7,6.6,25.3,0,12-1.7,18.2-3.2,21.4-1.2,2.6-2.5,3.7-3.4,3.9A3,3,0,0,0,2742.34,1209.5Z",
    fill: "#9a3b82"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M2524.94,1209.5h-5.3c.6,1.6,2.1,5.6,5.4,5.6,2,0,11.8-1.5,11.8-30.2,0-28.1-9-30.2-11.8-30.2-3.4,0-4.9,4.1-5.5,5.7h5.3a2.49,2.49,0,0,1,.5-.7c2,.5,6.6,5.7,6.6,25.3,0,19.8-4.8,24.7-6.6,25.3C2525.34,1210,2525.14,1209.8,2524.94,1209.5Z",
    fill: "#9a3b82"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M2568.44,1209.5h-5.3c.6,1.6,2.1,5.6,5.4,5.6,1.9,0,5.4-.8,8.1-6.4,2.4-5.1,3.7-13.1,3.7-23.8s-1.2-18.7-3.7-23.8c-2.7-5.6-6.2-6.4-8.1-6.4-3.4,0-4.9,4.1-5.5,5.7h5.3a2.49,2.49,0,0,1,.5-.7c1.2.2,2.4,1.5,3.4,3.6,1.4,3,3.2,9.2,3.2,21.7s-1.7,18.6-3.2,21.7c-1,2.1-2.3,3.4-3.4,3.6A3,3,0,0,0,2568.44,1209.5Z",
    fill: "#9a3b82"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M2611.94,1209.5h-5.3c.6,1.6,2.1,5.6,5.4,5.6,2.8,0,11.8-2.2,11.8-30.2,0-28.8-9.8-30.2-11.8-30.2-3.4,0-4.9,4.1-5.5,5.7h5.3a2.49,2.49,0,0,1,.5-.7c1.8.5,6.6,5.5,6.6,25.3,0,19.6-4.6,24.8-6.6,25.3A3,3,0,0,0,2611.94,1209.5Z",
    fill: "#9a3b82"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M2394.54,1209.5h-5.3c.6,1.6,2.1,5.6,5.4,5.6,1.5,0,5.3-.7,8.1-7,2.4-5.2,3.6-13.1,3.6-23.3,0-9.4-1.3-17.3-3.6-22.7-2.1-4.8-5.1-7.6-8.2-7.6-3.4,0-4.9,4.1-5.5,5.7h5.3c.2-.3.3-.6.4-.7.6.3,2,1.4,3.4,4.6s3.2,9.6,3.2,20.6c0,19.8-4.8,24.7-6.6,25.3C2394.84,1210,2394.74,1209.8,2394.54,1209.5Z",
    fill: "#9a3b82"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M2438,1209.5h-5.3c.6,1.6,2.1,5.6,5.4,5.6,1.5,0,5.3-.7,8.1-7,2.4-5.2,3.6-13.1,3.6-23.3,0-28.1-9-30.2-11.8-30.2-3.4,0-4.9,4.1-5.5,5.7h5.3a2.49,2.49,0,0,1,.5-.7c2,.5,6.6,5.7,6.6,25.3,0,19.8-4.8,24.7-6.6,25.3A1.33,1.33,0,0,0,2438,1209.5Z",
    fill: "#9a3b82"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M2481.54,1209.5h-5.3c.6,1.6,2.1,5.6,5.4,5.6,2.8,0,11.8-2.2,11.8-30.2,0-10.7-1.2-18.7-3.7-23.8-2.7-5.6-6.2-6.4-8.1-6.4-3.4,0-4.9,4.1-5.5,5.7h5.3a2.49,2.49,0,0,1,.5-.7c1.2.2,2.4,1.5,3.4,3.6,1.4,3,3.2,9.2,3.2,21.7,0,19.6-4.6,24.8-6.6,25.3C2481.84,1210,2481.64,1209.8,2481.54,1209.5Z",
    fill: "#9a3b82"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M2264.14,1209.5h-5.3c.6,1.6,2.1,5.6,5.4,5.6,3.1,0,6-2.8,8.2-7.6,2.4-5.4,3.6-13.2,3.6-22.7,0-11.1-2-18.1-3.6-22-2.2-5.2-5.2-8.2-8.2-8.2-3.4,0-4.9,4.1-5.5,5.7h5.3a5.74,5.74,0,0,0,.4-.7c.7.4,2.2,1.8,3.6,5.6,1.4,3.5,3,9.7,3,19.6,0,11.1-1.7,17.3-3.2,20.7-1.4,3.2-2.8,4.3-3.4,4.6C2264.44,1210,2264.24,1209.8,2264.14,1209.5Z",
    fill: "#9a3b82"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M2307.54,1209.5h-5.3c.6,1.6,2.1,5.6,5.4,5.6,3.1,0,6-2.8,8.2-7.6,2.4-5.4,3.6-13.2,3.6-22.7,0-19.6-6.1-30.2-11.8-30.2-3.4,0-4.9,4.1-5.5,5.7h5.3a5.74,5.74,0,0,0,.4-.7c.7.4,2.1,1.8,3.6,5.4,1.4,3.4,3,9.7,3,19.8,0,11.1-1.7,17.3-3.2,20.7-1.4,3.2-2.8,4.3-3.4,4.6A1.55,1.55,0,0,0,2307.54,1209.5Z",
    fill: "#9a3b82"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M2351,1209.5h-5.3c.6,1.6,2.1,5.6,5.4,5.6,1.5,0,5.2-.7,8.2-7.4,2.4-5.4,3.6-13.1,3.6-22.8,0-9.4-1.3-17.3-3.6-22.7-2.1-4.8-5.1-7.6-8.2-7.6-3.4,0-4.9,4.1-5.5,5.7h5.3c.2-.3.3-.6.4-.7.6.3,2,1.4,3.4,4.6s3.2,9.6,3.2,20.6c0,11.3-1.7,17.5-3.2,20.8-1.4,3.1-2.8,4.2-3.4,4.4A5.2,5.2,0,0,0,2351,1209.5Z",
    fill: "#9a3b82"
  })), /*#__PURE__*/React.createElement("g", {
    id: "CLOCK"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M2589,457.4h-350.6a36.66,36.66,0,0,1-36.7-36.7V70.1a36.66,36.66,0,0,1,36.7-36.7H2589a36.66,36.66,0,0,1,36.7,36.7V420.7A36.72,36.72,0,0,1,2589,457.4Z",
    fill: "#ffcf2d"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M2563.44,433.9h-357.5a36.66,36.66,0,0,1-36.7-36.7V39.7A36.66,36.66,0,0,1,2205.94,3h357.5a36.66,36.66,0,0,1,36.7,36.7V397.2A36.66,36.66,0,0,1,2563.44,433.9Z",
    fill: "#fff",
    stroke: "#ffcf2d",
    strokeMiterlimit: 10,
    strokeWidth: 6
  }), /*#__PURE__*/React.createElement("circle", {
    cx: 2384.74,
    cy: 218.4,
    r: 165,
    fill: "none",
    stroke: "#ffcf2d",
    strokeMiterlimit: 10,
    strokeWidth: 6
  }), /*#__PURE__*/React.createElement("polyline", {
    points: "2291.94 147.6 2384.74 218.4 2361.94 148.5",
    fill: "none",
    stroke: "#ffcf2d",
    strokeLinecap: "round",
    strokeMiterlimit: 10,
    strokeWidth: 6
  })), /*#__PURE__*/React.createElement("g", {
    id: "PAPER"
  }, /*#__PURE__*/React.createElement("polygon", {
    points: "2090.94 1493.5 1808.24 1493.5 1689.54 1350.9 1965.44 1350.9 2090.94 1493.5",
    fill: "#ffcf2d"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M2244,1500.9v88l-224,.9a51.79,51.79,0,0,1-52-51.8v-27.3a74.07,74.07,0,0,0-18.7-49.2l-73.9-83h275.9l70.6,69.7A73.51,73.51,0,0,1,2244,1500.9Z",
    fill: "#fff",
    stroke: "#66b0f0",
    strokeMiterlimit: 10,
    strokeWidth: 6
  }), /*#__PURE__*/React.createElement("path", {
    d: "M2344.84,1557.9a57.81,57.81,0,0,1-51.8,32H2017a58,58,0,0,0,51.8-32Z",
    fill: "#fff",
    stroke: "#66b0f0",
    strokeMiterlimit: 10,
    strokeWidth: 6
  })), /*#__PURE__*/React.createElement("g", {
    id: "CHARACTER"
  }, /*#__PURE__*/React.createElement("g", {
    id: "HOODY"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M2173.74,1009.8,2005.34,714a226.13,226.13,0,0,0-196.6-114.3H1178l22.1-47.7c-1.8,3.9-11.3,4.9-25.8,2.9-22.2-3-56-12.7-92-28.7-20.6-9.1-39.3-18.6-54.8-27.4-29.3-16.7-47-31.3-44.1-37.8l-322,528.1c-70.7,103.1,3.1,243.2,128.1,243.2a154.92,154.92,0,0,0,93.3-31.2l247.3-185.9a24.68,24.68,0,0,1,39.2,15.8l32.3,201.3h842.6C2158.54,1232.4,2230.24,1109,2173.74,1009.8Zm-374.8,23.1,27-61.4a13.26,13.26,0,0,1,24.2-.3l29.3,61.8h-80.5Z",
    fill: "#fe5244"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M1278.44,599.5c0-51.7,106.7-115.6,236.1-131.9,194.1-24.3,236.1,80.2,236.1,131.9",
    fill: "none",
    stroke: "#fe5244",
    strokeMiterlimit: 10,
    strokeWidth: 6
  }), /*#__PURE__*/React.createElement("path", {
    d: "M1728.24,600.4c0,46.3-213.7,141.1-213.7,141.1s-213.7-94.8-213.7-141.1,101.6-99.9,218.7-114.2C1688,465.6,1728.24,554,1728.24,600.4Z",
    fill: "#fe5244"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M1728.24,600.4c0,46.3-213.7,141.1-213.7,141.1s-213.7-94.8-213.7-141.1v-.6h427.4Z",
    fill: "#fff"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M1750.54,599.4c0,51.1-236,167.3-236,167.3s-236-116.1-236-167.3",
    fill: "none",
    stroke: "#fff",
    strokeMiterlimit: 10,
    strokeWidth: 6
  }), /*#__PURE__*/React.createElement("path", {
    d: "M1696.64,1230.1c13.2,0,23.9-43.7,23.9-97.5s-10.7-97.5-23.9-97.5",
    fill: "none",
    stroke: "#fff",
    strokeLinecap: "round",
    strokeMiterlimit: 10,
    strokeWidth: 5
  }), /*#__PURE__*/React.createElement("line", {
    x1: 1195.24,
    y1: 571.6,
    x2: 1010.14,
    y2: 941.7,
    fill: "none",
    stroke: "#fff",
    strokeMiterlimit: 10,
    strokeWidth: 5
  }), /*#__PURE__*/React.createElement("line", {
    x1: 1155.04,
    y1: 933.2,
    x2: 1185.64,
    y2: 1134.6,
    fill: "none",
    stroke: "#fff",
    strokeLinecap: "round",
    strokeMiterlimit: 10,
    strokeWidth: 5
  }), /*#__PURE__*/React.createElement("line", {
    x1: 1504.54,
    y1: 790.4,
    x2: 1524.54,
    y2: 790.4,
    fill: "none",
    stroke: "#fff",
    strokeLinecap: "round",
    strokeMiterlimit: 10,
    strokeWidth: 5
  }), /*#__PURE__*/React.createElement("line", {
    x1: 1504.54,
    y1: 814.2,
    x2: 1524.54,
    y2: 814.2,
    fill: "none",
    stroke: "#fff",
    strokeLinecap: "round",
    strokeMiterlimit: 10,
    strokeWidth: 5
  }), /*#__PURE__*/React.createElement("line", {
    x1: 1504.54,
    y1: 837.9,
    x2: 1524.54,
    y2: 837.9,
    fill: "none",
    stroke: "#fff",
    strokeLinecap: "round",
    strokeMiterlimit: 10,
    strokeWidth: 5
  }), /*#__PURE__*/React.createElement("line", {
    x1: 1504.54,
    y1: 861.6,
    x2: 1524.54,
    y2: 861.6,
    fill: "none",
    stroke: "#fff",
    strokeLinecap: "round",
    strokeMiterlimit: 10,
    strokeWidth: 5
  }), /*#__PURE__*/React.createElement("line", {
    x1: 1504.54,
    y1: 885.3,
    x2: 1524.54,
    y2: 885.3,
    fill: "none",
    stroke: "#fff",
    strokeLinecap: "round",
    strokeMiterlimit: 10,
    strokeWidth: 5
  }), /*#__PURE__*/React.createElement("line", {
    x1: 1504.54,
    y1: 909.1,
    x2: 1524.54,
    y2: 909.1,
    fill: "none",
    stroke: "#fff",
    strokeLinecap: "round",
    strokeMiterlimit: 10,
    strokeWidth: 5
  }), /*#__PURE__*/React.createElement("line", {
    x1: 1504.54,
    y1: 910.2,
    x2: 1524.54,
    y2: 910.2,
    fill: "none",
    stroke: "#fff",
    strokeLinecap: "round",
    strokeMiterlimit: 10,
    strokeWidth: 5
  }), /*#__PURE__*/React.createElement("line", {
    x1: 1504.54,
    y1: 933.9,
    x2: 1524.54,
    y2: 933.9,
    fill: "none",
    stroke: "#fff",
    strokeLinecap: "round",
    strokeMiterlimit: 10,
    strokeWidth: 5
  }), /*#__PURE__*/React.createElement("line", {
    x1: 1504.54,
    y1: 957.6,
    x2: 1524.54,
    y2: 957.6,
    fill: "none",
    stroke: "#fff",
    strokeLinecap: "round",
    strokeMiterlimit: 10,
    strokeWidth: 5
  }), /*#__PURE__*/React.createElement("line", {
    x1: 1504.54,
    y1: 980.2,
    x2: 1524.54,
    y2: 980.2,
    fill: "none",
    stroke: "#fff",
    strokeLinecap: "round",
    strokeMiterlimit: 10,
    strokeWidth: 5
  }), /*#__PURE__*/React.createElement("line", {
    x1: 1504.54,
    y1: 1004,
    x2: 1524.54,
    y2: 1004,
    fill: "none",
    stroke: "#fff",
    strokeLinecap: "round",
    strokeMiterlimit: 10,
    strokeWidth: 5
  }), /*#__PURE__*/React.createElement("line", {
    x1: 1504.54,
    y1: 1027.7,
    x2: 1524.54,
    y2: 1027.7,
    fill: "none",
    stroke: "#fff",
    strokeLinecap: "round",
    strokeMiterlimit: 10,
    strokeWidth: 5
  }), /*#__PURE__*/React.createElement("line", {
    x1: 1504.54,
    y1: 1051.4,
    x2: 1524.54,
    y2: 1051.4,
    fill: "none",
    stroke: "#fff",
    strokeLinecap: "round",
    strokeMiterlimit: 10,
    strokeWidth: 5
  }), /*#__PURE__*/React.createElement("line", {
    x1: 1504.54,
    y1: 1075.1,
    x2: 1524.54,
    y2: 1075.1,
    fill: "none",
    stroke: "#fff",
    strokeLinecap: "round",
    strokeMiterlimit: 10,
    strokeWidth: 5
  }), /*#__PURE__*/React.createElement("line", {
    x1: 1504.54,
    y1: 1098.9,
    x2: 1524.54,
    y2: 1098.9,
    fill: "none",
    stroke: "#fff",
    strokeLinecap: "round",
    strokeMiterlimit: 10,
    strokeWidth: 5
  }), /*#__PURE__*/React.createElement("line", {
    x1: 1504.54,
    y1: 1122.6,
    x2: 1524.54,
    y2: 1122.6,
    fill: "none",
    stroke: "#fff",
    strokeLinecap: "round",
    strokeMiterlimit: 10,
    strokeWidth: 5
  }), /*#__PURE__*/React.createElement("line", {
    x1: 1504.54,
    y1: 1146.3,
    x2: 1524.54,
    y2: 1146.3,
    fill: "none",
    stroke: "#fff",
    strokeLinecap: "round",
    strokeMiterlimit: 10,
    strokeWidth: 5
  }), /*#__PURE__*/React.createElement("line", {
    x1: 1504.54,
    y1: 1170,
    x2: 1524.54,
    y2: 1170,
    fill: "none",
    stroke: "#fff",
    strokeLinecap: "round",
    strokeMiterlimit: 10,
    strokeWidth: 5
  }), /*#__PURE__*/React.createElement("line", {
    x1: 1504.54,
    y1: 1171.2,
    x2: 1524.54,
    y2: 1171.2,
    fill: "none",
    stroke: "#fff",
    strokeLinecap: "round",
    strokeMiterlimit: 10,
    strokeWidth: 5
  }), /*#__PURE__*/React.createElement("line", {
    x1: 1504.54,
    y1: 1194.9,
    x2: 1524.54,
    y2: 1194.9,
    fill: "none",
    stroke: "#fff",
    strokeLinecap: "round",
    strokeMiterlimit: 10,
    strokeWidth: 5
  }), /*#__PURE__*/React.createElement("line", {
    x1: 1504.54,
    y1: 1218.6,
    x2: 1524.54,
    y2: 1218.6,
    fill: "none",
    stroke: "#fff",
    strokeLinecap: "round",
    strokeMiterlimit: 10,
    strokeWidth: 5
  }), /*#__PURE__*/React.createElement("line", {
    x1: 1502.44,
    y1: 758.1,
    x2: 1502.44,
    y2: 1134.6,
    fill: "none",
    stroke: "#fff",
    strokeMiterlimit: 10,
    strokeWidth: 5
  }), /*#__PURE__*/React.createElement("line", {
    x1: 1685.04,
    y1: 1034.9,
    x2: 1925.54,
    y2: 1034.9,
    fill: "none",
    stroke: "#fff",
    strokeLinecap: "round",
    strokeMiterlimit: 10,
    strokeWidth: 5
  })), /*#__PURE__*/React.createElement("g", {
    id: "BOOK"
  }, /*#__PURE__*/React.createElement("polygon", {
    points: "1015.84 1428.4 1783.74 1428.4 1711.54 1233.1 1099.04 1233.1 1015.84 1428.4",
    fill: "#fff",
    stroke: "#66b0f0",
    strokeMiterlimit: 10,
    strokeWidth: 6
  }), /*#__PURE__*/React.createElement("path", {
    d: "M1015.84,1428.4c0-27.6,73.2-77.5,192.1-84.3,127.3-7.2,194,72.8,192.1,84.3Z",
    fill: "#66b0f0"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M1399.94,1428.4s-33.8-158-330.5-125.8l64.1-155.9s243-44.2,266.5,86.4Z",
    fill: "#fff",
    stroke: "#66b0f0",
    strokeLinejoin: "round",
    strokeWidth: 6
  }), /*#__PURE__*/React.createElement("path", {
    d: "M1779.24,1416.1c-17.7-24.5-85.9-50.1-187.5-55.9-120.8-6.9-187,50.5-191.8,66.1V1233.1s86.2-98.4,311.6,0Z",
    fill: "#fff",
    stroke: "#66b0f0",
    strokeLinejoin: "round",
    strokeWidth: 6
  }), /*#__PURE__*/React.createElement("path", {
    d: "M1675.54,1335.3c-25.2-6.4-55.7-11.2-90.5-13.2a291.76,291.76,0,0,0-48.2,1.1c-36.7,4.1-65.6,15.1-86.2,26.9",
    fill: "none",
    stroke: "#66b0f0",
    strokeLinecap: "round",
    strokeLinejoin: "round",
    strokeWidth: 6
  }), /*#__PURE__*/React.createElement("path", {
    d: "M1666.64,1302c-24.1-5.7-52.8-10-85.2-11.9a291.76,291.76,0,0,0-48.2,1.1c-36.7,4.1-65.6,15.1-86.2,26.9",
    fill: "none",
    stroke: "#66b0f0",
    strokeLinecap: "round",
    strokeLinejoin: "round",
    strokeWidth: 6
  }), /*#__PURE__*/React.createElement("path", {
    d: "M1658.44,1268.8a511.88,511.88,0,0,0-79.7-10.7,291.76,291.76,0,0,0-48.2,1.1c-36.7,4.1-65.6,15.1-86.2,26.9",
    fill: "none",
    stroke: "#66b0f0",
    strokeLinecap: "round",
    strokeLinejoin: "round",
    strokeWidth: 6
  }), /*#__PURE__*/React.createElement("line", {
    x1: 1691.44,
    y1: 1224.3,
    x2: 1755.04,
    y2: 1397.5,
    fill: "none",
    stroke: "#66b0f0",
    strokeMiterlimit: 10,
    strokeWidth: 6
  }), /*#__PURE__*/React.createElement("path", {
    d: "M1783.84,1428.4h-383.9v-2.1c4.8-15.6,71-73,191.8-66.1,101.6,5.8,169.8,31.4,187.5,55.9Z",
    fill: "#66b0f0"
  })), /*#__PURE__*/React.createElement("g", {
    id: "HEAD"
  }, /*#__PURE__*/React.createElement("g", {
    id: "NECK"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M1637,599.7s-71.6,37.3-171,22.3h0a324.88,324.88,0,0,1-78.6-22.3V479.3l128.8-80.2,19.3,32.1Z",
    fill: "#e57281"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M1523.34,408.6a57.06,57.06,0,0,1,3.4,46.6L1466,622h0a324.88,324.88,0,0,1-78.6-22.3V479.3l129.4-82.7Z",
    fill: "#9a3b82"
  })), /*#__PURE__*/React.createElement("path", {
    id: "HAIR",
    d: "M1512.24,354.7s15.1-134.3-38.6-146.6c-41-9.4-61.4,21.5-61.4,21.5s-22.2-32.4-56.6-17.2c-32.7,14.4-30.4,59.3-15.7,55.7s-14.2-32.4-45.1-11.1c-34.2,23.5,0,62.3,0,62.3s-25.3-12.2-37,12.7c-14.5,30.9,68.3,97.5,68.3,97.5Z",
    fill: "#9a3b82"
  }), /*#__PURE__*/React.createElement("g", {
    id: "HEAD-2",
    "data-name": "HEAD"
  }, /*#__PURE__*/React.createElement("path", {
    id: "HEAD-3",
    "data-name": "HEAD",
    d: "M1430.44,289.8l-85.9,34.5a40.54,40.54,0,0,0-22.5,52.6l37.5,93.5c13.8,34.5,53.4,51.3,87.8,37.5l35.7-14.3c34.5-13.8,51.3-53.4,37.5-87.8L1483,312.3A40.54,40.54,0,0,0,1430.44,289.8Z",
    fill: "#e57281"
  }), /*#__PURE__*/React.createElement("g", {
    id: "EARS"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M1537.84,398.8l-17.3,7-18.8-46.8,17.3-7a20,20,0,0,1,26,11.1l3.9,9.7A19.92,19.92,0,0,1,1537.84,398.8Z",
    fill: "#e57281"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M1340.94,474l17.3-7-17.5-43.5-17.3,7a20,20,0,0,0-11.1,26l2.6,6.4A20,20,0,0,0,1340.94,474Z",
    fill: "#9a3b82"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M1516.74,383.8a15.81,15.81,0,0,1,8.8-20.5",
    fill: "none",
    stroke: "#9a3b82",
    strokeLinecap: "round",
    strokeMiterlimit: 10,
    strokeWidth: 5
  })), /*#__PURE__*/React.createElement("g", {
    id: "FACE"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M1432.64,340.5s20.3,7.6,46.1-4.6",
    fill: "none",
    stroke: "#9a3b82",
    strokeLinecap: "round",
    strokeMiterlimit: 10,
    strokeWidth: 5
  }), /*#__PURE__*/React.createElement("path", {
    d: "M1389.74,374.7s30.3-3.1,41.3,47.9",
    fill: "none",
    stroke: "#9a3b82",
    strokeLinecap: "round",
    strokeMiterlimit: 10,
    strokeWidth: 5
  }), /*#__PURE__*/React.createElement("path", {
    d: "M1475.74,439.2s-44.7-12-43.1,11.1",
    fill: "none",
    stroke: "#9a3b82",
    strokeLinecap: "round",
    strokeMiterlimit: 10,
    strokeWidth: 5
  }), /*#__PURE__*/React.createElement("ellipse", {
    cx: 1466.12,
    cy: 382.38,
    rx: 4.1,
    ry: 10.1,
    transform: "translate(-43.53 511.49) rotate(-19.51)",
    fill: "#9a3b82"
  }), /*#__PURE__*/React.createElement("ellipse", {
    cx: 1383.64,
    cy: 416.79,
    rx: 4.1,
    ry: 10.1,
    transform: "translate(-59.76 485.92) rotate(-19.51)",
    fill: "#9a3b82"
  })), /*#__PURE__*/React.createElement("g", {
    id: "GLASSES"
  }, /*#__PURE__*/React.createElement("circle", {
    cx: 1468.54,
    cy: 382.2,
    r: 28.9,
    fill: "none",
    stroke: "#ffcf2d",
    strokeLinecap: "round",
    strokeMiterlimit: 10,
    strokeWidth: 5
  }), /*#__PURE__*/React.createElement("circle", {
    cx: 1383.54,
    cy: 415.2,
    r: 28.9,
    fill: "none",
    stroke: "#ffcf2d",
    strokeLinecap: "round",
    strokeMiterlimit: 10,
    strokeWidth: 5
  }), /*#__PURE__*/React.createElement("line", {
    x1: 1410.54,
    y1: 404.8,
    x2: 1441.04,
    y2: 390.8,
    fill: "none",
    stroke: "#ffcf2d",
    strokeLinecap: "round",
    strokeMiterlimit: 10,
    strokeWidth: 5
  })))), /*#__PURE__*/React.createElement("g", {
    id: "ARMS"
  }, /*#__PURE__*/React.createElement("g", {
    id: "LEFT"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M1206.14,541c-1.7,3.9-11.3,4.9-25.8,2.9-22.2-3-56-12.7-92-28.7-20.6-9.2-39.3-18.6-54.7-27.4-29.3-16.7-47-31.3-44.1-37.8h0c2.9-6.4,25.4-3.3,57.2,7a577,577,0,0,1,57.6,22.4c35.6,15.8,66.5,31.2,84.7,43.1C1201.44,530.5,1207.94,537,1206.14,541Z",
    fill: "#fff",
    stroke: "#fe5244",
    strokeMiterlimit: 10,
    strokeWidth: 6
  }), /*#__PURE__*/React.createElement("path", {
    d: "M1375.84,338.2l-27.2,105.1-24.5-61a46.58,46.58,0,0,1,25-60Z",
    fill: "#9a3b82"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M1376.84,336.3l-54,93.6a35,35,0,0,1-30.3,17.5h-55.8a20.16,20.16,0,0,0-18.6,12.5l-29,62.7-8.5,18.3c-24.5-3.3-58.6-13.9-91.2-28.4-12.2-5.4-24.1-11.1-35.1-16.8L1069,465l26.3-54.9a152.61,152.61,0,0,1,62-71.3l54.4-32.7a46.74,46.74,0,0,1,23.9-6.6H1328a33.21,33.21,0,0,1,14.6,3.3l27.8,13.2A14.48,14.48,0,0,1,1376.84,336.3Z",
    fill: "#e57281"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M1246.24,339.3h66a32.69,32.69,0,0,1,14.1,3.2l26.7,12.8a14,14,0,0,1,6.1,19.5",
    fill: "none",
    stroke: "#9a3b82",
    strokeLinecap: "round",
    strokeMiterlimit: 10,
    strokeWidth: 5
  }), /*#__PURE__*/React.createElement("path", {
    d: "M1229.84,367.7h66a32.69,32.69,0,0,1,14.1,3.2l26.7,12.8a14,14,0,0,1,6.1,19.5",
    fill: "none",
    stroke: "#9a3b82",
    strokeLinecap: "round",
    strokeMiterlimit: 10,
    strokeWidth: 5
  }), /*#__PURE__*/React.createElement("path", {
    d: "M1210.54,404.8h66a32.69,32.69,0,0,1,14.1,3.2l26.7,12.8a14,14,0,0,1,6.1,19.5",
    fill: "none",
    stroke: "#9a3b82",
    strokeLinecap: "round",
    strokeMiterlimit: 10,
    strokeWidth: 5
  }), /*#__PURE__*/React.createElement("path", {
    d: "M1180.74,540.9c-24.5-3.3-58.6-13.9-91.2-28.4-12.2-5.4-24.1-11.1-35.1-16.8l16.6-33.9c11.1,4.2,22,9,34.2,14.5,35.6,15.8,66.7,32.3,84.9,44.2Z",
    fill: "#9a3b82"
  }), /*#__PURE__*/React.createElement("line", {
    x1: 1191.04,
    y1: 444.7,
    x2: 1237.84,
    y2: 444.7,
    fill: "none",
    stroke: "#9a3b82",
    strokeLinecap: "round",
    strokeMiterlimit: 10,
    strokeWidth: 5
  })), /*#__PURE__*/React.createElement("g", {
    id: "RIGHT"
  }, /*#__PURE__*/React.createElement("ellipse", {
    cx: 1684.64,
    cy: 1132.6,
    rx: 23.9,
    ry: 99.7,
    fill: "#fff"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M1708.54,1132.6a359.53,359.53,0,0,1-2.9,47.3,59.75,59.75,0,0,1-34.9,34.2,60.66,60.66,0,0,1-21,3.8H1559a20.74,20.74,0,0,0-20.7,20.7v2.8a22.26,22.26,0,0,1-32.6,19.7l-42.6-22.3a23.2,23.2,0,0,1-12.4-20.5V1185a39.78,39.78,0,0,1,15.8-31.7l65-48.9a63.24,63.24,0,0,1,38.1-12.7h136.7A347,347,0,0,1,1708.54,1132.6Z",
    fill: "#e57281"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M1547.94,1123.9l-59.7,44.9a36.61,36.61,0,0,0-14.5,29.1v30.6a21.15,21.15,0,0,0,11.4,18.8",
    fill: "none",
    stroke: "#9a3b82",
    strokeLinecap: "round",
    strokeMiterlimit: 10,
    strokeWidth: 5
  }), /*#__PURE__*/React.createElement("path", {
    d: "M1578.34,1137.3l-59.7,44.9a36.61,36.61,0,0,0-14.5,29.1v30.6a21.15,21.15,0,0,0,11.4,18.8",
    fill: "none",
    stroke: "#9a3b82",
    strokeLinecap: "round",
    strokeMiterlimit: 10,
    strokeWidth: 5
  }), /*#__PURE__*/React.createElement("path", {
    d: "M1708.54,1132.6a359.53,359.53,0,0,1-2.9,47.3,59.75,59.75,0,0,1-34.9,34.2c-6.1-18.1-10.1-47.8-10.1-81.5a397.36,397.36,0,0,1,2.1-40.9h43.7A371,371,0,0,1,1708.54,1132.6Z",
    fill: "#9a3b82"
  })))), /*#__PURE__*/React.createElement("g", {
    id: "CUP"
  }, /*#__PURE__*/React.createElement("ellipse", {
    cx: 1882.24,
    cy: 1268.8,
    rx: 108.4,
    ry: 9.1,
    fill: "#ffcf2d"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M1972.44,1275.7h-44.8a75.18,75.18,0,0,1-75.2-75.2v-63.9h195.3v63.8A75.28,75.28,0,0,1,1972.44,1275.7Z",
    fill: "#fff",
    stroke: "#ffcf2d",
    strokeMiterlimit: 10,
    strokeWidth: 6
  }), /*#__PURE__*/React.createElement("path", {
    d: "M2075,1191.3h-27.4v-48.7H2075a21.32,21.32,0,0,1,21.3,21.3v6.2A21.3,21.3,0,0,1,2075,1191.3Z",
    fill: "none",
    stroke: "#ffcf2d",
    strokeMiterlimit: 10,
    strokeWidth: 6
  }), /*#__PURE__*/React.createElement("ellipse", {
    cx: 1950.04,
    cy: 1135.9,
    rx: 98.5,
    ry: 19.7,
    fill: "#3fb1b5",
    stroke: "#fff",
    strokeMiterlimit: 10,
    strokeWidth: 5
  }), /*#__PURE__*/React.createElement("path", {
    d: "M1852.54,1151.9c0,10.9,43.7,19.7,97.5,19.7s97.5-8.8,97.5-19.7",
    fill: "none",
    stroke: "#ffcf2d",
    strokeMiterlimit: 10,
    strokeWidth: 6
  }), /*#__PURE__*/React.createElement("path", {
    d: "M1852.54,1172.8c0,10.9,43.7,19.7,97.5,19.7s97.5-8.8,97.5-19.7",
    fill: "none",
    stroke: "#ffcf2d",
    strokeMiterlimit: 10,
    strokeWidth: 6
  }), /*#__PURE__*/React.createElement("path", {
    d: "M1852.54,1193.7c0,10.9,43.7,19.7,97.5,19.7s97.5-8.8,97.5-19.7",
    fill: "none",
    stroke: "#ffcf2d",
    strokeMiterlimit: 10,
    strokeWidth: 6
  }), /*#__PURE__*/React.createElement("path", {
    d: "M1854,1214.6c0,10.9,43,19.7,96,19.7s96-8.8,96-19.7",
    fill: "none",
    stroke: "#ffcf2d",
    strokeMiterlimit: 10,
    strokeWidth: 6
  }), /*#__PURE__*/React.createElement("path", {
    d: "M1861.54,1235.5c0,10.9,39.6,19.7,88.5,19.7s88.5-8.8,88.5-19.7",
    fill: "none",
    stroke: "#ffcf2d",
    strokeMiterlimit: 10,
    strokeWidth: 6
  }), /*#__PURE__*/React.createElement("path", {
    d: "M1946.14,1100.9c-9.6-6.6-39.5-69.5-2.5-95.2,28.4-19.8,33.9,31.5,20.8,27.2-22.8-7.5-36.7-107.9,22.8-101.7,26.2,2.7,23.3,40,0,41",
    fill: "none",
    stroke: "#fff",
    strokeLinecap: "round",
    strokeMiterlimit: 10,
    strokeWidth: 5
  })), /*#__PURE__*/React.createElement("g", {
    id: "LAPTOP"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M783.14,1394.7H291.64a32.18,32.18,0,0,1-29.9-20.2l-134.5-332.4a24.24,24.24,0,0,1,22.4-33.3h491.5A32.18,32.18,0,0,1,671,1029l134.5,332.4A24.16,24.16,0,0,1,783.14,1394.7Z",
    fill: "#fff",
    stroke: "#ffcf2d",
    strokeMiterlimit: 10,
    strokeWidth: 6
  }), /*#__PURE__*/React.createElement("path", {
    d: "M760.34,1397.1H291.44a30.78,30.78,0,0,1-28.5-19.2l-128.3-317.1a23,23,0,0,1,21.4-31.7h468.9a30.78,30.78,0,0,1,28.5,19.2l128.3,317.1A23.09,23.09,0,0,1,760.34,1397.1Z",
    fill: "#ffcf2d"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M472.44,1252.9a51.45,51.45,0,0,1-36.6-15.2,42,42,0,0,1,0-59.6,34.52,34.52,0,0,1,48.8,0,28.43,28.43,0,0,1,0,40.2,23.54,23.54,0,0,1-33.3,0,4,4,0,1,1,5.7-5.7,15.51,15.51,0,0,0,22,0,20.4,20.4,0,0,0,0-28.9,26.56,26.56,0,0,0-37.6,0,33.79,33.79,0,0,0-10,24.2,34.38,34.38,0,0,0,10,24.2,43.7,43.7,0,0,0,61.8,0,4,4,0,1,1,5.7,5.7A51.36,51.36,0,0,1,472.44,1252.9Z",
    fill: "#fff"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M959,1429.9H292.24a13.87,13.87,0,0,1-13.9-13.9v-6.7a13.87,13.87,0,0,1,13.9-13.9H959a13.87,13.87,0,0,1,13.9,13.9v6.7A14,14,0,0,1,959,1429.9Z",
    fill: "#fff",
    stroke: "#ffcf2d",
    strokeMiterlimit: 10,
    strokeWidth: 6
  }))))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgAiPlugins);
export default __webpack_public_path__ + "static/media/AiPlugins.b3bfb732a8459f89896ec81b3ac35cac.svg";
export { ForwardRef as ReactComponent };